import FetchClient from './fetchClient';

export interface ApiClient {
  getRaw<T, T2 = Partial<T>, T3 = T>(
    path: string,
    builder?: (properties: T2) => Promise<T3> | T3
  ): Promise<T3>;

  get<T, T2 = Partial<T>>(
    path: string,
    builder?: (properties: T2) => Promise<T> | T
  ): Promise<Array<T>>;

  login(username: string, password: string, rememberMe: boolean): Promise<void>;

  signUp(
    username: string,
    password: string,
    name: string,
    contactPreference: boolean
  ): Promise<void>;

  forgotPassword(email: string): Promise<void>;

  resetPassword(token: string, email: string, password: string): Promise<void>;

  logout(ignoreFailure: boolean): Promise<void>;

  updateUser(
    name: string,
    colour: string,
    password?: string,
    currentPassword?: string
  ): Promise<void>;

  updatePassword(password: string, currentPassword: string): Promise<void>;

  post(path: string, body: Object): Promise<Response>;

  put(path: string, body: Object): Promise<Response>;

  delete(path: string, body: Object): Promise<Response>;
}

export const client = new FetchClient();

export default client;



// WEBPACK FOOTER //
// ./src/app/api/client.ts